<template>

<div class="game">

    <core-gamename :game="item.game" class="game-name" />

	<app-view-common-insight_play-tags :item="item" :field="field" v-if="field.status === 'enabled'" />

	<div class="game-version" v-if="showLocation">{{ item.play.location }}</div> 

	<app-view-common-insight_play-players :item="item" :inline="true" :field="field" v-if="field.players === 'enabled'" />

    <app-view-common-tags :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showTags" />

</div>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky'],

	computed: {

        showLocation: function() {

            return this.field.location === 'enabled'

        },

        showTags: function() {

            return this.field.tags === 'enabled'

        }

    }

}

</script>

<style scoped>

.game {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.game-name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
    display: block;
    cursor: pointer;
    overflow: hidden;
}

.is-desktop .game-name {
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
	min-width: 0;
}

.is-mobile .game-name {
	font-size: 14px;
	line-height: 14px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;   
  	overflow: hidden;
  	word-break: break-word;
}

.field.is-condensed .game-name {
	font-size: 14px;
	line-height: 14px;
}

.is-mobile .field.is-condensed .game-name {
	font-size: 12px;
	line-height: 12px;
}

.is-desktop .game-name:hover {
	text-decoration: underline;
}

.game-version {
	color: #666;
	font-size: 11px;
	margin-top: 2px;
	line-height: 11px;
	font-weight: 400;
}

.is-mobile .game-version {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;   
  	overflow: hidden;
	margin-top: 0px;
  	word-break: break-word;
}

</style>